import { motion } from 'framer-motion';
import { PageHero } from '@/components/common/Sections';
import { CTABanner } from '@/components/common/Cards';
import { LEADERSHIP, IMAGES } from '@/lib/constants';
import { Quotes } from '@phosphor-icons/react';

export default function ChairmanMessagePage() {
  const chairman = LEADERSHIP[0]; // Dr. P.B. Boss

  return (
    <div className="page-transition">
      <PageHero
        title="Chairman's Message"
        subtitle="A word from our founder"
        backgroundImage={IMAGES.airport}
      />

      <section data-testid="chairman-message" className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-5 gap-12 items-start">
              {/* Chairman Image */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="md:col-span-2"
              >
                <div className="relative">
                  <img
                    src={chairman.image}
                    alt={chairman.name}
                    className="w-full aspect-[3/4] object-cover object-top"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-[#0A1F3D] p-6">
                    <h3 className="text-xl font-bold font-['Playfair_Display'] text-white">
                      {chairman.name}
                    </h3>
                    <p className="text-[#D4AF37] text-sm">{chairman.designation}</p>
                  </div>
                </div>
              </motion.div>

              {/* Message */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="md:col-span-3"
              >
                <Quotes size={64} className="text-[#D4AF37]/20 mb-6" weight="fill" />
                
                <div className="space-y-6 text-[#4A5568] leading-relaxed">
                  <p className="text-xl font-light text-[#0A1F3D]">
                    Dear Valued Travelers and Partners,
                  </p>
                  
                  <p>
                    When I founded Osaka Air Travels in 1993, I had a simple dream – to bring the world
                    closer to the people of Kerala. What began as a humble venture has now blossomed into
                    one of the most trusted names in travel management across India.
                  </p>
                  
                  <p>
                    Over the past three decades, we have had the privilege of serving over a million happy
                    travelers. Each journey we've facilitated has been more than just a transaction – it has
                    been a story, an experience, a memory that lasts a lifetime. This trust that you have
                    placed in us is something we cherish deeply and work hard to honor every single day.
                  </p>
                  
                  <p>
                    The travel industry has evolved dramatically since 1993. From handwritten tickets to
                    digital platforms, from limited options to a world of possibilities – we have embraced
                    every change while staying true to our core values of integrity, excellence, and
                    customer-first service.
                  </p>
                  
                  <p>
                    Today, the Osaka Group comprises five specialized companies, each dedicated to serving
                    your unique travel needs. Whether you're a student dreaming of studying abroad, a
                    corporate traveler seeking seamless business trips, or a family planning that
                    once-in-a-lifetime vacation – we have the expertise to make it happen.
                  </p>
                  
                  <p>
                    As we look to the future, our commitment remains unwavering. We will continue to innovate,
                    to expand, and to raise the bar for travel services. With our new Osaka Connect super app,
                    we're bringing 24 travel products to your fingertips – making travel planning easier and
                    more accessible than ever before.
                  </p>
                  
                  <p>
                    I want to extend my heartfelt gratitude to every customer who has trusted us with their
                    travel dreams, to every partner who has supported our journey, and to every member of
                    the Osaka family who has worked tirelessly to make this possible.
                  </p>
                  
                  <p className="text-xl font-medium text-[#0A1F3D]">
                    Your world is our expertise. Let us continue to explore it together.
                  </p>
                  
                  <div className="pt-6 border-t border-slate-200">
                    <p className="font-bold text-[#0A1F3D]">Warm Regards,</p>
                    <p className="text-[#D4AF37] font-semibold mt-2">{chairman.name}</p>
                    <p className="text-sm text-[#4A5568]">{chairman.designation}, Osaka Group</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
